import { render, staticRenderFns } from "./TeamDialog.vue?vue&type=template&id=73fe8fe4&"
import script from "./TeamDialog.vue?vue&type=script&lang=js&"
export * from "./TeamDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports